export default __webpack_public_path__ + "static/media/Group 81.c2d27e4b.png";